export default __webpack_public_path__ + "static/media/jdcandidate.f25128ac.svg";